import { LayersErrors, WarningErrors } from "../jsxProviders";

export const errorLayersDescMap = new Map<string, string>([
  [LayersErrors.Wav, "Sadly we cannot render WAV files."],
  [
    LayersErrors.AudOffset,
    "Audio layers should not be outside the current working area.",
  ],
  [LayersErrors.AudLock, "Audio layers should not be locked for rendering."],
  [LayersErrors.LayerLocked, "Layers should not be locked for rendering."],
  [LayersErrors.VidTrack, "Video layers cannot have track matte."],
  [LayersErrors.UnsupportedFormat, "AI or PSD files are not supported."],
  [
    LayersErrors.CompCollapse,
    "'Collapse transform' switch is on and can't be rendered.",
  ],
  [LayersErrors.TextDeformed, "Cannot render deformed text."],
  [
    LayersErrors.NameError,
    "Cannot render layers with special characters in their name. '_', '-' are allowed.",
  ],
  [LayersErrors.UnknownError, "Unknown error."],
  [LayersErrors.FontError, "Font error"],
]);

export const errorLayersFixDescMap = new Map<string, string>([
  [LayersErrors.Wav, "Please replace the following layers with Mp3 files"],
  [
    LayersErrors.AudOffset,
    "Please make sure that the following mp3 layers start after the the beginning and before the end of the timeline (better if you wrap the audio layer with a new composition)",
  ],
  [LayersErrors.AudLock, "Please unlock the following audio layers"],
  [LayersErrors.LayerLocked, "Please unlock the following layers"],
  [
    LayersErrors.VidTrack,
    "Please choose 'No track matte' on the following mp4 layers",
  ],
  [
    LayersErrors.CompCollapse,
    "Please uncheck 'collapse transform' on the following layers",
  ],
  [LayersErrors.UnsupportedFormat, "Please remove the unsupported layers"],
  [LayersErrors.TextDeformed, "Reset font scale to 100%"],
  [LayersErrors.NameError, "Please rename"],
  [
    LayersErrors.UnknownError,
    "Please try again later or check your network connection",
  ],
  [
    LayersErrors.FontError,
    "Fonts are missing. Please make sure they are valid",
  ],
]);

export const warningLayersDescMap = new Map<string, string>([
  [
    WarningErrors.videoOrder,
    "Video layers should be at the bottom of the layer stack",
  ],
]);

export const warningLayersFixDescMap = new Map<string, string>([
  [
    WarningErrors.videoOrder,
    "Please move the following video layers to the bottom of the layer stack. MP5 rendered video will place videos at the bottom",
  ],
]);
